module.exports = __webpack_public_path__ + "static/media/68a344f978911bbeeda903f6_3487b4d6a931b25e51c333486600a08a_TC-Logo-Main 2.2d641bc6.png";